<template>
  <div :class="$style.checkboxContainer">
    <v-checkbox ref="checkbox"
                color="#102E52"
                :input-value="inputValue"
                :value="value"
                :disabled="disabled"
                @change="onChange($event)">
      <template v-slot:label>
        <slot name="label"></slot>
      </template>
    </v-checkbox>
    <span :class="$style.checkbox">
      <p @click="onLabelClick($event)">
        {{ label }}
      </p>
      <app-tooltip v-if="tooltip"
                   :class="$style.tooltip"
                   :centered="centeredTooltip"
                   :down="bottomTooltip"
                   :width="tooltipWidth">
        <template v-slot:tooltipHeader>
          <slot name="tooltipHeader" />
        </template>
        <template v-slot:tooltipText>
          <slot name="tooltipText" />
        </template>
      </app-tooltip>
    </span>
  </div>

</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      type: Boolean,
      default: false,
    },
    centeredTooltip: {
      type: Boolean,
      default: false,
    },
    bottomTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipWidth: {
      type: String,
      default: 'auto',
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
    },
    onLabelClick(e) {
      this.$refs.checkbox.onChange(e);
    },
  },
};
</script>

<style lang="scss" module>
.checkboxContainer {
  position: relative;
}

.checkbox {
  position: absolute;
  top: 4px;
  left: 30px;

  p {
    display: inline;
    padding-bottom: 16px;
    cursor: pointer;
  }
}

.tooltip {
  white-space: normal;
}
</style>

<style lang="scss">
@import "@/styles/variables.scss";

.v-input--checkbox.v-input--selection-controls.v-input {
  .v-label {
    color: $main-text-color;
    font-size: 1.7rem;
    line-height: 2.4rem;
  }

  .v-messages {
    display: none;
  }

  .theme--light.v-icon {
    color: $left-sidebar-color;
  }
}
</style>
